module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "p-4"
  }, [_c('div', [_c('h5', [_vm._v("Channel")]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      error: _vm.$v.refundObject.refundChannels.$error
    }
  }, [_c('channel-selector', {
    attrs: {
      "reservation": _vm.getSelectedReservation
    },
    on: {
      "input": _vm.channelChanged
    },
    model: {
      value: (_vm.refundObject.refundChannels),
      callback: function($$v) {
        _vm.$set(_vm.refundObject, "refundChannels", $$v)
      },
      expression: "refundObject.refundChannels"
    }
  }), _vm._v(" "), (_vm.$v.refundObject.refundChannels.$error) ? _c('div', {
    staticClass: "messages"
  }, [(!_vm.$v.refundObject.refundChannels.required) ? _c('span', [_vm._v("Select one.")]) : _vm._e()]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "mt-1 mb-2"
  }, [(_vm.selectedScope === _vm.REFUND_SCOPE.SELECT_PAYMENT && _vm.selectedPayment) ? _c('payment-row', {
    attrs: {
      "payment": _vm.selectedPayment,
      "reservation": _vm.getSelectedReservation,
      "plain": true
    }
  }) : _c('div', {
    staticClass: "refund__all-summary"
  }, [_vm._v("\n            All payments — " + _vm._s(_vm.formatPrice(_vm.scopeTotal)) + " €\n        ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "mt-3"
  }, [_c('h5', [_vm._v("When to refund")]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      error: _vm.$v.refundObject.isRequest.$error,
      'opacity-50': _vm.disableRefundRequestArea
    }
  }, [_c('div', {
    staticClass: "whenToRefund radius-normal"
  }, [_c('div', {
    staticClass: "whenToRefund__option d-flex align-items-center p-2 pointer",
    on: {
      "click": function($event) {
        return _vm.clickRefundRequestType(false)
      }
    }
  }, [_c('div', {
    staticClass: "mx-2"
  }, [_c('radio', {
    attrs: {
      "name": "isRequest",
      "disabled": _vm.disableRefundRequestArea,
      "value": false
    },
    on: {
      "input": _vm.$v.refundObject.isRequest.$touch
    },
    model: {
      value: (_vm.refundObject.isRequest),
      callback: function($$v) {
        _vm.$set(_vm.refundObject, "isRequest", $$v)
      },
      expression: "refundObject.isRequest"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "darker"
  }, [_vm._v("Refund customer now")])]), _vm._v(" "), _c('div', {
    staticClass: "whenToRefund__option d-flex align-items-center p-2 pointer",
    on: {
      "click": function($event) {
        return _vm.clickRefundRequestType(true)
      }
    }
  }, [_c('div', {
    staticClass: "mx-2"
  }, [_c('radio', {
    attrs: {
      "name": "isRequest",
      "disabled": _vm.disableRefundRequestArea,
      "value": true
    },
    on: {
      "input": _vm.$v.refundObject.isRequest.$touch
    },
    model: {
      value: (_vm.refundObject.isRequest),
      callback: function($$v) {
        _vm.$set(_vm.refundObject, "isRequest", $$v)
      },
      expression: "refundObject.isRequest"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "darker"
  }, [_vm._v("Request refund")])])]), _vm._v(" "), (_vm.$v.refundObject.isRequest.$error) ? _c('div', {
    staticClass: "messages"
  }, [(!_vm.$v.refundObject.isRequest.required) ? _c('span', [_vm._v("Select one.")]) : _vm._e()]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "mt-3"
  }, [_c('h5', [_vm._v("Payment Method")]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      error: _vm.$v.refundObject.paymentType.$error
    }
  }, [_c('payment-method-selector', {
    attrs: {
      "allowedMethods": _vm.allowedPaymentMethods
    },
    on: {
      "change": _vm.paymentMethodPickerChange
    },
    model: {
      value: (_vm.refundObject.paymentType),
      callback: function($$v) {
        _vm.$set(_vm.refundObject, "paymentType", $$v)
      },
      expression: "refundObject.paymentType"
    }
  }), _vm._v(" "), (_vm.$v.refundObject.paymentType.$error) ? _c('div', {
    staticClass: "messages"
  }, [(!_vm.$v.refundObject.paymentType.required) ? _c('span', [_vm._v("Select one.")]) : _vm._e()]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "mt-3"
  }, [_c('h5', [_vm._v("Refund type")]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      error: _vm.$v.selectedRefundType.$error
    }
  }, [_c('div', {
    staticClass: "d-flex flex-wrap"
  }, _vm._l((_vm.getRefundTypes), function(refundType) {
    return _c('button', {
      directives: [{
        name: "tooltip",
        rawName: "v-tooltip",
        value: (_vm.refundTypeDisabledReason(refundType)),
        expression: "refundTypeDisabledReason(refundType)"
      }],
      key: refundType.id,
      staticClass: "refundTypeBtn btn bg-lightest darker bold mr-2 mb-2",
      class: {
        'selected': _vm.isRefundTypeSelected(refundType),
        'disabled': _vm.disableRefundTypeArea || _vm.isRefundTypeDisabled(refundType)
      },
      attrs: {
        "type": "button",
        "disabled": _vm.isRefundTypeDisabled(refundType)
      },
      on: {
        "click": function($event) {
          return _vm.selectRefundType(refundType)
        }
      }
    }, [_vm._v("\n                    " + _vm._s(refundType.label) + "\n                ")])
  }), 0), _vm._v(" "), (_vm.$v.selectedRefundType.$error) ? _c('div', {
    staticClass: "messages"
  }, [(!_vm.$v.selectedRefundType.required) ? _c('span', [_vm._v("Select one.")]) : _vm._e()]) : _vm._e()])]), _vm._v(" "), (_vm.selectedRefundType != null) ? _c('div', [(_vm.selectedRefundType.id == _vm.REFUND_TYPE.PERCENTAGE_OR_VALUE) ? _c('div', {
    staticClass: "mt-3"
  }, [_c('h5', [_vm._v("Percentage or Value")]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      error: _vm.$v.selectedRefundType.$error
    }
  }, [_c('div', {
    staticClass: "percentValue col-sm-12 d-flex align-items-center"
  }, [_c('div', {
    staticClass: "percentValue__label bold mr-2"
  }, [_vm._v("Value:")]), _vm._v(" "), _c('div', {
    staticClass: "d-flex flex-column"
  }, [_c('div', {
    staticClass: "d-flex"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.refundObject.amount),
      expression: "refundObject.amount",
      modifiers: {
        "number": true
      }
    }, {
      name: "numFloat",
      rawName: "v-numFloat"
    }],
    staticClass: "percentValue__input glued-right",
    attrs: {
      "type": "number",
      "max": _vm.isEuroMode ? _vm.refundMaximumValue : 100,
      "step": _vm.isEuroMode ? 0.01 : 1,
      "min": 0
    },
    domProps: {
      "value": (_vm.refundObject.amount)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.refundObject, "amount", _vm._n($event.target.value))
      }, _vm.onAmountInput],
      "keydown": _vm.preventDecimalInput,
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('v-select', {
    staticClass: "percentValue__select glued-left",
    attrs: {
      "options": _vm.getPercentageOrCurrency
    },
    on: {
      "input": function($event) {
        return _vm.valueTypeChanged($event)
      }
    },
    model: {
      value: (_vm.selectedValueType),
      callback: function($$v) {
        _vm.selectedValueType = $$v
      },
      expression: "selectedValueType"
    }
  })], 1), _vm._v(" "), (_vm.isEuroMode && _vm.refundMaximumValue != null) ? _c('div', {
    staticClass: "fs-smaller darker mt-1"
  }, [_vm._v("\n                            Max: " + _vm._s(_vm.formatPrice(_vm.refundMaximumValue)) + " €\n                        ")]) : _vm._e()])]), _vm._v(" "), (_vm.$v.selectedRefundType.$error) ? _c('div', {
    staticClass: "messages"
  }, [(!_vm.$v.selectedRefundType.isValid) ? _c('span', [(_vm.isEuroMode && _vm.refundMaximumValue != null) ? _c('span', [_vm._v("Value must be between 0 and " + _vm._s(_vm.formatPrice(_vm.refundMaximumValue)) + " €.")]) : _c('span', [_vm._v("Invalid value.")])]) : _vm._e()]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.selectedRefundType.id == _vm.REFUND_TYPE.ITEM_VALUE) ? _c('div', {
    staticClass: "mt-3"
  }, [_c('h5', [_vm._v("Reservation Items")]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      error: _vm.$v.refundItems.$error
    }
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [(_vm.calculationResult == null) ? _c('div', {
    staticClass: "w-100 text-center py-4"
  }, [_c('loader')], 1) : _c('div', [(_vm.calculationResult != null) ? _c('reduce-quantity', {
    attrs: {
      "calculations": _vm.calculationResult,
      "compact": true
    },
    on: {
      "change": function($event) {
        return _vm.requestCalculations()
      }
    },
    model: {
      value: (_vm.refundObject.refundItems),
      callback: function($$v) {
        _vm.$set(_vm.refundObject, "refundItems", $$v)
      },
      expression: "refundObject.refundItems"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "releaseQty d-flex align-items-center p-2 radius-normal bg-lighter pointer",
    class: {
      'releaseQty--disabled': _vm.releaseQuantityBlocked
    },
    on: {
      "click": _vm.toggleReleaseQuantity
    }
  }, [_c('div', {
    staticClass: "mx-2"
  }, [_c('checkbox', {
    attrs: {
      "disabled": _vm.releaseQuantityBlocked
    },
    model: {
      value: (_vm.refundObject.isToReleaseQuantity),
      callback: function($$v) {
        _vm.$set(_vm.refundObject, "isToReleaseQuantity", $$v)
      },
      expression: "refundObject.isToReleaseQuantity"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "darker"
  }, [_c('div', {
    staticClass: "releaseQty__title bold"
  }, [_vm._v("Make refunded items available again")]), _vm._v(" "), _c('div', {
    staticClass: "releaseQty__subtitle"
  }, [_vm._v("This will allow to re-sell refunded items")]), _vm._v(" "), (_vm.releaseQuantityBlocked) ? _c('div', {
    staticClass: "releaseQty__warning"
  }, [_vm._v("\n                                    The reservation must keep at least one passenger.\n                                ")]) : _vm._e()])]), _vm._v(" "), (_vm.$v.refundItems.$error) ? _c('div', {
    staticClass: "messages"
  }, [(!_vm.$v.refundItems.isValid) ? _c('span', [_vm._v("Select at least one item to refund.")]) : _vm._e()]) : _vm._e()], 1)])])]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "mt-3"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      error: _vm.$v.refundObject.refundReasonType.$error
    }
  }, [_c('v-select', {
    attrs: {
      "options": _vm.getRefundReasons,
      "disabled": _vm.disableReasonArea,
      "label": "text",
      "placeholder": "Select reason"
    },
    on: {
      "input": _vm.reasonChanged
    },
    model: {
      value: (_vm.selectedReason),
      callback: function($$v) {
        _vm.selectedReason = $$v
      },
      expression: "selectedReason"
    }
  }), _vm._v(" "), (_vm.refundObject.refundReasonType == 0) ? _c('div', {
    staticClass: "mt-3"
  }, [_c('label', [_vm._v("Describe the refund reason")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.refundObject.reason),
      expression: "refundObject.reason"
    }],
    staticClass: "w-100",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.refundObject.reason)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.refundObject, "reason", $event.target.value)
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.$v.refundObject.refundReasonType.$error) ? _c('div', {
    staticClass: "messages"
  }, [(!_vm.$v.refundObject.refundReasonType.required) ? _c('span', [_vm._v("Reason is required.")]) : _vm._e()]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "mt-3"
  }, [_c('div', {
    staticClass: "bold dark text-right"
  }, [(_vm.isLoadingCalculations) ? _c('loader') : _c('div', {
    staticClass: "d-flex flex-column"
  }, [(_vm.refundValueProcessed.now != null) ? _c('div', {
    staticClass: "d-flex flex-grow-1 justify-content-end"
  }, [_c('span', [_vm._v("Refund now: "), _c('span', {
    staticClass: "color-1"
  }, [_vm._v(_vm._s(_vm.formatPrice(_vm.refundValueProcessed.now)) + " €")])])]) : _vm._e(), _vm._v(" "), (_vm.refundValueProcessed.later != null) ? _c('div', {
    staticClass: "d-flex flex-grow-1 justify-content-end"
  }, [_c('span', [_vm._v("Refund later: "), _c('span', {
    staticClass: "color-1"
  }, [_vm._v(_vm._s(_vm.formatPrice(_vm.refundValueProcessed.later)) + " €")])])]) : _vm._e(), _vm._v(" "), (_vm.refundMaximumValue != null && _vm.refundValue > _vm.refundMaximumValue) ? _c('div', {
    staticClass: "messages d-flex flex-grow-1 justify-content-end mt-1"
  }, [_c('span', [_vm._v("Exceeds maximum refundable amount of " + _vm._s(_vm.formatPrice(_vm.refundMaximumValue)) + " €.")])]) : _vm._e()])], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h5', [_vm._v("Reason "), _c('span', {
    staticClass: "color-6"
  }, [_vm._v("*")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-b9f8bd10", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b9f8bd10"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/tools/modal/ReservationRefundTransaction/Step2Details.vue
// module id = 2151
// module chunks = 0